import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { VdpModule } from 'site-modules/shared/components/inventory/vdp-module/vdp-module';
import { NAVIGATION_IDS } from 'site-modules/shared/constants/inventory/vdp-navigation';
import { VehicleHistory } from 'site-modules/inventory/components/vehicle-history/vehicle-history';
import { InventoryEntities } from 'client/data/models/inventory';
import { VehicleEntities } from 'client/data/models/vehicle';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';

export function VehicleExtendedDetails({
  vehicleData = {},
  vinData = {},
  isVlaPage = false,
  isSeparateModule = false,
  className = '',
}) {
  const { type } = vinData;

  const details = (
    <Fragment>
      {!isNew(type) && (
        <VdpModule className={classNames('bg-white', { 'mt-1': !isSeparateModule })} indentationSize={1.5}>
          <ScrollElement id={NAVIGATION_IDS.HISTORY}>
            <VehicleHistory vinData={vinData} vehicle={vehicleData} isVlaPage={isVlaPage} />
          </ScrollElement>
        </VdpModule>
      )}
    </Fragment>
  );

  if (!isSeparateModule) {
    return details;
  }

  return (
    <VdpModule className={classNames('bg-cool-gray-90', className)} titleClassName="heading-3">
      {details}
    </VdpModule>
  );
}

VehicleExtendedDetails.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  vehicleData: VehicleEntities.MakeModelSubmodelYear,
  isVlaPage: PropTypes.bool,
  isSeparateModule: PropTypes.bool,
  className: PropTypes.string,
};
